import { SubscriptionTypePipe } from '$core/modal/subscription-orders/manage-subscription-order/subscription-type.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CapitalizeFirstPipe } from './capitalize-first.pipe';
import { HighlightPipe } from './hightlight.pipe';
import { NewDatePipe } from './new-date.pipe';
import { RemoveFromArrayPipe } from './remove-from-array.pipe';
import { SafePipe } from './safe.pipe';
import { DeclinationPipe } from './declination.pipe';
import { ReplacePipe } from './replace.pipe';
import { MarkdownPipe } from './markdown.pipe';
import { ContactPersonNamePipe } from './contact-person-name.pipe';
import { OrderByPipe } from './order-by.pipe';
import { ShortenPipe } from './shorten.pipe';
import { StripTagsPipe } from './strip-tags.pipe';
import { BytesPipe } from './bytes.pipe';
import { FilterByPipe } from './filter-by.pipe';
import { GroupByPipe } from './group-by.pipe';

@NgModule({
  declarations: [
    NewDatePipe,
    SafePipe,
    RemoveFromArrayPipe,
    SubscriptionTypePipe,
    CapitalizeFirstPipe,
    HighlightPipe,
    DeclinationPipe,
    ReplacePipe,
    MarkdownPipe,
    ContactPersonNamePipe,
    OrderByPipe,
    ShortenPipe,
    StripTagsPipe,
    BytesPipe,
    FilterByPipe,
    GroupByPipe,
  ],
  imports: [CommonModule],
  exports: [
    NewDatePipe,
    SafePipe,
    RemoveFromArrayPipe,
    SubscriptionTypePipe,
    CapitalizeFirstPipe,
    HighlightPipe,
    DeclinationPipe,
    ReplacePipe,
    MarkdownPipe,
    ContactPersonNamePipe,
    OrderByPipe,
    ShortenPipe,
    StripTagsPipe,
    BytesPipe,
    FilterByPipe,
    GroupByPipe,
  ],
})
export class PipesModule {}
